import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import { useComponentRegistry } from "../../../componentRegistry";
import { getVehicleTitle, showFuelTypeTag } from "../../../../../../shared-logic/utils/uscUtils";
import { EcoTagType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { UscTrackingLocation } from "../../../../../utils/tracking";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./UscVehicleInformation.styles";

type UscVehicleInformationHeaderPropsType = {
    trackingLocation: UscTrackingLocation;
};

const UscVehicleInformationHeader = ({
    trackingLocation,
}: UscVehicleInformationHeaderPropsType): JSX.Element | null => {
    const result = useUscSelector((state) => state.vehicle.result);

    const SaveButton = useComponentRegistry("SaveButton");

    if (!result) return null;

    const vehicleTitle = getVehicleTitle(result.product);
    const { engine, versionName } = result.product;
    const { code: fuelTypeCode, description: fuelTypeName } = engine.marketingFuelType;

    return (
        <Styles.Header>
            <div>
                <Text tag="h1" variant="h4">
                    {vehicleTitle}
                </Text>
                <Styles.VehicleInfo as="h2">
                    {showFuelTypeTag(fuelTypeCode) && (
                        <Text tag="span" variant={EcoTagType.Hybrid}>
                            {fuelTypeName}
                        </Text>
                    )}
                    {!!versionName && (
                        <Text tag="span" variant="body-small-regular" color="grey-7">
                            {versionName}
                        </Text>
                    )}
                </Styles.VehicleInfo>
            </div>
            <SaveButton trackingLocation={trackingLocation} />
        </Styles.Header>
    );
};

export default UscVehicleInformationHeader;
